/**
 * Neptune trident — uses the chrome+gold PNG asset for premium 3D feel.
 * The v5 asset is portrait (~668×1024); we size by *height* and let width
 * follow the natural aspect ratio so the trident never looks squished.
 */
const TRIDENT_W = 668;
const TRIDENT_H = 1024;

export default function NeptuneTrident({ size = 56, className = "" }) {
  // `size` is interpreted as the trident's height. Width comes from the
  // native aspect ratio so the proportions stay true to the source.
  const w = Math.round(size * (TRIDENT_W / TRIDENT_H));
  return (
    <img
      src="/neptune-trident-v5.png"
      alt="Neptune trident"
      width={w}
      height={size}
      draggable={false}
      className={className}
      style={{
        display: "block",
        width: `${w}px`,
        height: `${size}px`,
        objectFit: "contain",
        userSelect: "none",
        // Keep crispness when the layer is composited (avoids blurry interpolation on retina)
        imageRendering: "auto",
      }}
    />
  );
}
